<template>
    <v-content>
        <v-container>
            <v-card>
                <v-tabs v-model="tab" color="primary" grow>
                    <v-tab>
                        <v-icon left>fa-users</v-icon>
                        En turno ahora
                        <v-chip class="ml-2" color="success" dark x-small>{{ usersEnTurno.length }}</v-chip>
                    </v-tab>
                    <v-tab>
                        <v-icon left>fa-history</v-icon>
                        Historial
                    </v-tab>
                </v-tabs>

                <v-divider />

                <v-tabs-items v-model="tab">

                    <!-- TAB 1: Usuarios en turno ahora -->
                    <v-tab-item>
                        <v-list v-if="usersEnTurno.length > 0" two-line>
                            <template v-for="(u, index) in usersEnTurno">
                                <v-list-item :key="index">
                                    <v-list-item-avatar>
                                        <v-icon color="success" size="32">fa-user</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-bold">
                                            {{ u.first_name }} {{ u.last_name }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            {{ u.position }}<span v-if="u.area"> — {{ u.area }}</span>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-chip color="success" dark small>En turno</v-chip>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider :key="'d' + index" inset />
                            </template>
                        </v-list>
                        <div v-else class="text-center grey--text py-10">
                            <v-icon size="48" color="grey lighten-1">fa-users</v-icon>
                            <p class="mt-3">No hay usuarios en turno en este momento.</p>
                        </div>
                    </v-tab-item>

                    <!-- TAB 2: Historial con filtros -->
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <v-row align="center">
                                    <v-col cols="12" sm="5">
                                        <v-dialog
                                                ref="dialog"
                                                v-model="modal"
                                                :return-value.sync="date"
                                                persistent
                                                width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="date"
                                                        label="Seleccione fecha"
                                                        prepend-icon="event"
                                                        readonly
                                                        outlined
                                                        dense
                                                        hide-details
                                                        v-on="on"
                                                />
                                            </template>
                                            <v-date-picker v-model="date" scrollable locale="es-co">
                                                <v-spacer/>
                                                <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                                                <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-col>
                                    <v-col cols="12" sm="5">
                                        <v-select
                                                prepend-icon="fa-user"
                                                label="Seleccione un usuario"
                                                v-model="user"
                                                :items="usersSorted"
                                                item-text="full_name"
                                                item-value="id"
                                                outlined
                                                dense
                                                hide-details
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="2">
                                        <v-btn color="primary" block @click="getTurnos()">
                                            <v-icon left>fa-search</v-icon>
                                            Buscar
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <v-divider />

                            <div v-if="turnos.length === 0" class="text-center grey--text py-10">
                                <v-icon size="48" color="grey lighten-1">fa-history</v-icon>
                                <p class="mt-3">Seleccione una fecha y un usuario para ver el historial.</p>
                            </div>

                            <v-timeline v-else :dense="$vuetify.breakpoint.smAndDown" class="px-4 py-4">
                                <v-timeline-item v-for="(item, index) in turnos" :key="index">
                                    <v-card>
                                        <v-card-title class="blue darken-1 justify-center white--text">
                                            {{ item.createdAt.toDate() | moment("dddd, MMMM Do YYYY, h:mm:ss a") }}
                                        </v-card-title>
                                        <v-container>
                                            <v-row align="center">
                                                <v-col cols="2" class="text-center">
                                                    <v-icon size="48">{{ item.turno ? 'fa-door-open' : 'fa-door-closed' }}</v-icon>
                                                </v-col>
                                                <v-col cols="10">
                                                    <h3 class="display-1 text-center">{{ item.turno ? 'ENTRADA' : 'SALIDA' }}</h3>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card>
                                </v-timeline-item>
                            </v-timeline>
                        </v-card>
                    </v-tab-item>

                </v-tabs-items>
            </v-card>
        </v-container>
    </v-content>
</template>

<script>
    import {db} from "../plugins/db";
    import {mapState, mapGetters} from "vuex";
    export default {
        name: "Turno",
        data(){
            return{
                tab: 0,
                modal: false,
                date: '',
                user: '',
                turnos: []
            }
        },
        methods:{
            async getTurnos(){
                if (!this.user || !this.date) return;
                const startOfDay = this.$moment(this.date).startOf('day').toDate();
                const endOfDay   = this.$moment(this.date).endOf('day').toDate();
                this.turnos = [];
                try {
                    const snapshot = await db.collection('turnos')
                        .where('user.id', '==', this.user)
                        .get();
                    snapshot.forEach(e => {
                        const data = e.data();
                        const fecha = data.createdAt.toDate();
                       if (fecha >= startOfDay && fecha <= endOfDay) {
                            this.turnos.push(data);
                        }
                    });
                    this.turnos.sort((a, b) => b.createdAt.toDate() - a.createdAt.toDate());
                } catch (err) {
                    alert('Error al obtener los turnos: ' + err.message);
                }
            }
        },
        computed:{
            ...mapState({
                users: state => state.user.users
            }),
            ...mapGetters(['usersCountEnTurno']),
            usersEnTurno(){
                return this.usersCountEnTurno
            },
            usersSorted(){
                return [...this.users]
                    .map(u => ({ id: u.id, ...u, full_name: `${u.first_name} ${u.last_name}` }))
                    .sort((a, b) => a.full_name.localeCompare(b.full_name))
            }
        }
    }
</script>

<style scoped>
</style>
